import Axios from 'axios'
import React, { Component } from 'react'
import { getUser } from '../../../actions/session'
import { ACCOUNT_DASHBOARD_API } from '../../../config/rest_endpoints'
import Container from '../../common/application_container'
import CustomLoader from '../../common/loader'
import { Notifications } from '../../common/notification'

export default class DashboardTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tableData:[],
            User: getUser(),
            isGetting: false,
        }
    }

    componentDidMount() {
        this.getTable()
    }

    getTable() {
        const {User} = this.state
        this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${ACCOUNT_DASHBOARD_API}`,{headers}).then(res=>{
            if(res) {
                console.log(`res`, res)
                var resp = res.data.data
                this.setState({
                    tableData:resp,
                    isGetting:false
                })
            }
        }).catch(err=>{
            Notifications.notify(err,"Failed",'error')
            this.setState({
                isGetting:false
            })
        })
    }

    __renderAccountTable() {
        const { tableData } = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (tableData == null) {
            return nullData
        }
        else {
           return tableData.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td>{row.accountName}</td>
                        <td>{row.balance}</td>
                        <td>{row.spent}</td>
                        <td>{row.sessions}</td>
                        <td>{row.sessionsPCT}</td>
                        <td>{row.CPS}</td>
                        <td>{row.CPSPCT}</td>
                        <td>{row.ASR}</td>
                        <td>{row.ACD}</td>
                        <td>{row.SDP}</td>
                        <td>{row.yesterdaySpent}</td>
                        <td>{row.profit}</td>
                        <td>{row.rate}</td>
                        {/* <td>{row.active === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
                        <td><i className="fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)}></i></td> */}
                    </tr>
                )
            })
        }

    }


    render() {
        const {isGetting} = this.state
        return (
            <Container title="Dashboard" title1="Stats" icon="icon-archive">
                <div className="card card-body border-left-dark-alpha border-right-dark-alpha ">
                   
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer mt-3">
                        <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                            <div class="input-group">
                                    <input type="text" class="form-control border-right-0" placeholder="Filter Account" />

                                    <span class="input-group-append">
                                        <button class="btn bg-blue" type="button"><i class="fa fa-search"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="datatable-scroll " style={{ overflowX: 'auto' }}>
                            <table className="table datatable-basic table-striped bg-light border dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="bg-dark">
                                        <th>Account Name</th>
                                        <th>Balance</th>
                                        <th>Spent</th>
                                        <th>Sessions</th>
                                        <th>Sessions %</th>
                                        <th>CPS</th>
                                        <th>CPS %</th>
                                        <th>ASR</th>
                                        <th>ACD</th>
                                        <th>SDP</th>
                                        <th>Spent Yesterday</th>
                                        <th>Profit</th>
                                        <th>Rate</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.__renderAccountTable()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="datatable-footer mt-1">
                        {totalCount >= 9 ?  
                            <div className="mt-3">
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={itemsCount}
                                    totalItemsCount={totalCount}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div> :''}

                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div> */}
                    </div>
                </div>
            </Container>
        )
    }
}
